import React from "react"
import { OrderPaymentBrinkZeroPayment } from "lib/types/generated/graphql-types"
import {
  getPaymentMethodDisplayName,
  getPaymentProviderDisplayName
} from "helpers/getPaymentDisplayName"
import { Container, Row } from "./Styled"
import ListEntry from "../../../../../components/Order/Ui/ListEntry"

type Props = {
  orderPayment: OrderPaymentBrinkZeroPayment
}

const BrinkZeroPayment = ({ orderPayment }: Props) => {
  if (!orderPayment) return null

  return (
    <>
      <Container>
        <Row>
          <ListEntry
            label={"Payment provider"}
            value={getPaymentProviderDisplayName(orderPayment.providerName)}
          />{" "}
          <ListEntry
            label={"Payment method"}
            value={getPaymentMethodDisplayName(orderPayment.method)}
          />
          <ListEntry label={"Payment reference"} value={orderPayment.reference} />
          <ListEntry label={"Original provider"} value={orderPayment.originalProvider.name} />
          <ListEntry label={"Original provider ID"} value={orderPayment.originalProvider.id} />
        </Row>
      </Container>
    </>
  )
}

export default BrinkZeroPayment
